import axios from 'axios';
import config from './config';
import Cookies from "js-cookie";
import router from '@/router'

// 使用vuex做全局loading时使用
// import store from '@/store'
// 将blob对象转化为json（文件类型调用ajax 取后端的返回值做特殊处理）
function fileToJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = res => {
      const { result } = res.target // 得到字符串
      const data = JSON.parse(result) // 解析成json对象
      resolve(data)
    } // 成功回调
    reader.onerror = err => {
      reject(err)
    } // 失败回调
    reader.readAsText(new Blob([file]), 'utf-8') // 按照utf-8编码解析
  })
}

export default function $axios(options) {
  return new Promise((resolve, reject) => {
    let tmpbaseURL = options.hostUrl ? options.hostUrl : config.baseUrl;
    let tmpTimeout = options.timeout ? options.timeout : config.timeout;
    let tmpHeaders = options.formType ? config.formHeaders : config.headers;
    let downloadInitial = options.downloadInitial;  // 仅用于文件下载 参数为进度条对象
    let downloadFileName = options.downloadFileName;  // 仅用于文件下载 值为自定义文件名

    const instance = axios.create({
      baseURL: tmpbaseURL,
      headers: tmpHeaders,
      timeout: tmpTimeout,
      withCredentials: config.withCredentials,
      responseType: options.isBlob ? 'blob' : 'text',
      /*
       *@Author: czc
       *@Date: 2021-09-10 10:52:31
       *@Description: 下载进度方法
      */
      onDownloadProgress: function (progressEvent) {
        try {
          if (downloadInitial == undefined && progressEvent.total !== 0) {
            throw console.error("请传入downloadInitial参数");
          }
          var index = downloadInitial[0].$el.getAttribute("idx");
          if (downloadInitial !== undefined && progressEvent.total === 0) {
            // 失败时清空进度条对象
            downloadInitial[0].$parent.progressArray[index]["loaded"] = 'error';
            downloadInitial[0].$parent.progressArray[index]["total"] = 'error';
            downloadInitial[0].$parent.progressArray[index]["fileName"] = '';
            throw console.error("后端方法不支持进度条,请联系后端解决");
          }
          if (downloadFileName == undefined && progressEvent.total !== 0) {
            // 失败时清空进度条对象
            downloadInitial[0].$parent.progressArray[index]["loaded"] = 'error';
            downloadInitial[0].$parent.progressArray[index]["total"] = 'error';
            downloadInitial[0].$parent.progressArray[index]["fileName"] = '';
            throw console.error("请传入downloadFileName参数");
          }
          // 默认下载进度条
          if (progressEvent.total !== 0 && downloadInitial != undefined) {
            // 传入当前加载值 总大小 文件名
            downloadInitial[0].$parent.progressArray[index]["loaded"] = progressEvent.loaded;
            downloadInitial[0].$parent.progressArray[index]["total"] = progressEvent.total;
            downloadInitial[0].$parent.progressArray[index]["fileName"] = downloadFileName;
          }
        } catch (e) {
          return new Error("进度条方法参数错误.")
        }

        // 可通过传入onDownloadProgress参数自定义下载进度方法
        if (options.onDownloadProgress && typeof options.onDownloadProgress == 'function') {
          options.onDownloadProgress(progressEvent)
        }
      },
      onUploadProgress: function (uploadEvent) {
        if (options.onUploadProgress && typeof options.onUploadProgress == 'function') {
          options.onUploadProgress(uploadEvent)
        }
      }
    })

    // request 拦截器
    instance.interceptors.request.use(
      config => {
        let token = sessionStorage.getItem('tkn');
        // 1. 请求开始的时候可以结合 vuex 开启全屏 loading 动画
        // console.log(store.state.loading)
        // console.log('准备发送请求...')
        if (sessionStorage.getItem("expireDate")) {
          if (sessionStorage.getItem("expireDate") < Date.now()) {
            sessionStorage.clear();
            localStorage.clear();
            xyjVue.$message.error("登录过期，请重新登录")
          }
        }
        // 2. 带上token
        if (token) {
          config.headers.token = token
        } else {
          // 重定向到登录页面
          router.push('/Login')
        }
        // 3. 根据请求方法，序列化传来的参数，根据后端需求是否序列化
        if (config.method === 'post') {

        }
        return config
      },
      error => {
        // 请求错误时
        console.log('request:', error)
        // 1. 判断请求超时
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {

          console.log('timeout请求超时')
        }
        // 2. 需要重定向到错误页面
        const errorInfo = error.response
        console.log(errorInfo)
        if (errorInfo) {
          error = errorInfo.data  // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status; // 404 403 500 ...
          router.push({
            path: `/error/${errorStatus}`
          })
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        let data;
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.headers.filename) {
          data = {};
          data.data = response.data;
          data.filename = response.headers.filename;
        } else if (response.data == undefined) {
          data = JSON.parse(response.request.responseText)
        } else {
          data = response.data
        }

        // 根据返回的code值来做不同的处理
        switch (data.rc) {
          case 1:
            console.log(data.desc)
            break;
          case 0:
            store.commit('changeState')
          // console.log('登录成功')
          default:
        }
        // 若不是正确的返回code，且已经登录，就抛出错误
        // const err = new Error(data.desc)
        // err.data = data
        // err.response = response
        // throw err
        return data
      },
      async err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误'
              break
            case 401:
              err.message = '未授权，请登录'
              break
            case 403:
              sessionStorage.clear();
              Cookies.remove('token');
              router.push('/Login');
              err.message = '拒绝访问';
              break
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`
              break
            case 408:
              err.message = '请求超时'
              break
            case 500:
              if (err.response.config.responseType == "blob") {
                err.message = (await fileToJson(err.response.data)).message
              } else if (err.response.headers.xyjerror) {
                err.message = decodeURIComponent(err.response.headers.xyjerror);
              } else {
                err.message = err.response.data.message + "，错误号：" + err.response.data.status;
              }
			        if (err.message == "请重新登录") {
                err.message = "账号已在其他地方登陆，请重新登陆";
              }
              if (err.response.data.message == "请重新登录" || err.message == "请重新登录") {
                sessionStorage.clear();
                Cookies.remove('token');
                router.push('/Login');
              }
              break
            case 501:
              err.message = '服务未实现'
              break
            case 502:
              err.message = '网关错误'
              break
            case 503:
              err.message = '服务不可用'
              break
            case 504:
              err.message = '网关超时'
              break
            case 505:
              err.message = 'HTTP版本不受支持'
              break
            default:
          }
        }
        return Promise.reject(err) // 返回接口返回的错误信息
      }
    )

    // 请求处理

    instance(options).then(res => {
      resolve(res);
      return false
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/http/axios.js